import { axiosPrivate } from "@/api/axios";
import type { User } from "@/lib/columns";

type UsersResponse = {
  data?: User[];
  success?: boolean;
  total_pages?: number | null;
};

const PAGE_LIMIT = 25;

export async function fetchAllUsers(): Promise<User[]> {
  let firstResponse;
  try {
    firstResponse = await axiosPrivate.get<UsersResponse>("/users/", {
      params: { current_page: 1, limit: PAGE_LIMIT },
    });
  } catch {
    try {
      const response = await axiosPrivate.get<UsersResponse>("/users/");
      if (response.data?.success && Array.isArray(response.data.data)) {
        return response.data.data;
      }
    } catch {
      return [];
    }
    return [];
  }

  if (!firstResponse.data?.success) {
    return [];
  }

  const firstPageUsers = Array.isArray(firstResponse.data.data)
    ? firstResponse.data.data
    : [];
  const totalPages = Math.max(1, Number(firstResponse.data.total_pages) || 1);

  if (totalPages === 1) {
    return firstPageUsers;
  }

  const remainingResponses = await Promise.allSettled(
    Array.from({ length: totalPages - 1 }, (_, index) =>
      axiosPrivate.get<UsersResponse>("/users/", {
        params: { current_page: index + 2, limit: PAGE_LIMIT },
      })
    )
  );

  const remainingUsers = remainingResponses.flatMap((response) =>
    response.status === "fulfilled" && Array.isArray(response.value.data?.data)
      ? response.value.data.data
      : []
  );

  return [...firstPageUsers, ...remainingUsers];
}
